// extracted by mini-css-extract-plugin
export default {"title":"SellerPage_title__GunjB","body":"SellerPage_body__GyeeV"};